import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    Title,
    Subtitle,
} from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import {
    SurgeryNotesMainContainer,
    SurgeryNotesContainer,
    UpdatedSurgeryDateContainer,
    UpdatedSurgeryDateTitle,
} from './SurgeryNotes.styled';
import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import { convertTime24To12 } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { formatDateddmmmyy } from 'src/utils/dateUtils';

const SurgeryNotes = ({
    toggleCard,
    isSurgeryNotes,
    notes,
    currentOrderType, isConsignmentBilling
}) => {
    const { t } = useTranslation();
    const surgeryNotes = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.surgeryNotes
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
   const isCondensedView = useSelector(
          (state) => state.loginReducer.isCondensedView
      );
    return (
        <>
            <CollapsableCard
                id="orders-surgeryNotes-surgeryNotes-notes"
                title={
                    currentOrderType === 'ZLC' ||
                    currentOrderType === 'ZLC_SURGERY'
                        ? t('scheduleSurgery.surgery.SurgeryNotes.surgeryNotes')
                        : t('reportUsage.customerCareNotes')
                }
                onClick={() => toggleCard('isSurgeryNotes', !isSurgeryNotes)}
                isExpanded={isSurgeryNotes}
                padding={'0.8rem'}
                cursor={'pointer'}
                titleFontSize={'15px'}
                mobileMargin = {!isConsignmentBilling && isCondensedView &&  '10px 16px 2px 16px'}
                mainContainerMarginBottom={'25px'}
            >
                {isSurgeryNotes && notes ? (
                    <SurgeryNotesMainContainer>
                        {notes?.map((surgeryNote, index) => {
                            return (
                                <SurgeryNotesContainer
                                    key={index}
                                    setMarginBottom={true}
                                    wordBreak={'break-all'}
                                >
                                    {surgeryNote?.header &&
                                    surgeryNote?.header?.length > 0 ? (
                                        <Subtitle
                                            setBackground="#EBEBEB"
                                            fontSize="13px"
                                            fontColor="#4F4F4F"
                                            setFontWeight="Bold"
                                            setPadding="5px 5px 5px 10px"
                                            setMargin="0px 0px 20px 0px"
                                            style={{ width: '100%' }}
                                        >
                                            {surgeryNote.header.toUpperCase()}
                                        </Subtitle>
                                    ) : null}
                                    {surgeryNote?.notesAr.length > 0
                                        ? surgeryNote.notesAr.map((it, ind) => {
                                              return (
                                                  <SurgeryNotesContainer
                                                      key={ind}
                                                      setMarginBottom={true}
                                                      wordBreak={'break-all'}
                                                  >
                                                      {it?.creationDate ? (
                                                          <Subtitle
                                                              showAstrisk={
                                                                  false
                                                              }
                                                              fontSize={'13px'}
                                                              setFontWeight={
                                                                  'bold'
                                                              }
                                                              style={{
                                                                  marginRight:
                                                                      '10px',
                                                              }}
                                                          >
                                                              {it?.typeOfNote==='BatchReservationNotes' ? (`${t(
                                                                  'equity.surgery.backendNote'
                                                              )} `) :(`${t(
                                                                  'equity.surgery.createdBy'
                                                              )} `)}
                                                              {it?.typeOfNote!=='BatchReservationNotes' && (it.user)}
                                                               {' | '}
                                                              {formatDateddmmmyy(
                                                                  new Date(
                                                                      it.creationDate
                                                                  ),countryISOCode,true
                                                              )}
                                                              {' | '}{' '}
                                                              {convertTime24To12(
                                                                  new Date(
                                                                      it.creationDate
                                                                  ),
                                                                  true
                                                              )}
                                                          </Subtitle>
                                                      ) : null}
                                                      {it?.updatedSurgeryDate && (
                                                          <UpdatedSurgeryDateTitle
                                                              showAstrisk={
                                                                  false
                                                              }
                                                              isNotNeeded={true}
                                                          >
                                                              <UpdatedSurgeryDateContainer>
                                                                  <div>
                                                                      {t(
                                                                          'orders.orderSummaryTabs.surgery'
                                                                      )}
                                                                  </div>
                                                                  <div>
                                                                      {getDisplayDate(
                                                                          new Date(
                                                                              it.updatedSurgeryDate
                                                                          )
                                                                      )}{' '}
                                                                      {convertTime24To12(
                                                                          new Date(
                                                                              it.updatedSurgeryDate
                                                                          ),
                                                                          true
                                                                      )}{' '}
                                                                      {getTimeZoneName()}
                                                                  </div>
                                                              </UpdatedSurgeryDateContainer>
                                                          </UpdatedSurgeryDateTitle>
                                                      )}
                                                      {it?.notes ? (
                                                          <Subtitle
                                                              fontSize={'14px'}
                                                              key={index}
                                                          >
                                                              {it.notes}
                                                          </Subtitle>
                                                      ) : null}
                                                  </SurgeryNotesContainer>
                                              );
                                          })
                                        : null}
                                </SurgeryNotesContainer>
                            );
                        })}
                    </SurgeryNotesMainContainer>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default SurgeryNotes;
